/* Mali · Guía Glow + Protocolo Glow 7 Días */
(function () {
  'use strict';

  // Puntitos de carrusel: <div class="car" data-mg-car> + <div class="dots" data-mg-dots>
  document.querySelectorAll('[data-mg-car]').forEach(function (car) {
    var dots = car.parentElement.querySelector('[data-mg-dots]');
    if (!dots) return;
    var n = car.children.length;
    if (n < 2) { dots.remove(); return; }
    for (var i = 0; i < n; i++) dots.appendChild(document.createElement('i'));
    var marks = dots.children;
    var paint = function () {
      var max = car.scrollWidth - car.clientWidth;
      if (max <= 2) { dots.style.display = 'none'; return; }
      dots.style.display = '';
      var idx = Math.round((car.scrollLeft / max) * (n - 1));
      for (var j = 0; j < n; j++) marks[j].classList.toggle('on', j === idx);
    };
    car.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  });

  // Galería del hero: miniaturas cambian la imagen principal
  document.querySelectorAll('[data-mg-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-mg-main] img');
    g.querySelectorAll('[data-mg-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.src = t.getAttribute('data-src');
        main.removeAttribute('srcset');
        g.querySelectorAll('[data-mg-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  // Fecha de entrega estimada (días hábiles)
  var dn = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  var mn = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  var addBiz = function (n) {
    var x = new Date(), k = 0;
    while (k < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) k++; }
    return x;
  };
  var fmt = function (x) { return dn[x.getDay()] + ' ' + x.getDate() + ' de ' + mn[x.getMonth()]; };
  document.querySelectorAll('[data-mg-delivery]').forEach(function (el) {
    var a = parseInt(el.getAttribute('data-min'), 10) || 3;
    var b = parseInt(el.getAttribute('data-max'), 10) || 5;
    el.textContent = 'entre el ' + fmt(addBiz(a)) + ' y el ' + fmt(addBiz(b));
  });

  // Quiz de tipo de piel (pre-landing)
  document.querySelectorAll('[data-mg-quiz]').forEach(function (q) {
    var res = q.querySelector('[data-mg-quiz-res]');
    var hint = q.querySelector('[data-mg-quiz-hint]');
    q.querySelectorAll('button[data-title]').forEach(function (b) {
      b.addEventListener('click', function () {
        q.querySelectorAll('button[data-title]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        res.querySelector('b').textContent = b.getAttribute('data-title');
        res.querySelector('span').textContent = b.getAttribute('data-text');
        res.hidden = false;
        if (hint) hint.hidden = true;
      });
    });
  });
})();
